import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ProviderAppointmentsUIHelpers";

const ProviderAppointmentsUIContext = createContext();

export function useProviderAppointmentsUIContext() {
  return useContext(ProviderAppointmentsUIContext);
}

export const ProviderAppointmentsUIConsumer = ProviderAppointmentsUIContext.Consumer;

export function ProviderAppointmentsUIProvider({ ProviderAppointmentsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams, 
    openDetailProviderAppointmentPage: ProviderAppointmentsUIEvents.openDetailProviderAppointmentPage
  };

  return (
    <ProviderAppointmentsUIContext.Provider value={value}>
      {children}
    </ProviderAppointmentsUIContext.Provider>
  );
}
